import { Divider } from "@mui/material";
import { PNL_COLORS } from "constants/constants";
import { TooltipNS } from "pages/DashboardPages/ProcessTilesControls/TooltipNS";
import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { TopDowntime } from "./topDowntimeChartUtils";

export function TopDowntimesChart({
  topDowntimes,
  totalDurationMs,
}: {
  topDowntimes: TopDowntime[];
  totalDurationMs: number;
}) {
  const { translate } = useFlightTranslation();
  return (
    <TopDowntimesChartStyles>
      <div className="totalDowntime">
        <div className="superscript">
          {translate("Total_downtime_this_shift")}
        </div>
        <div className="title">
          <span>{translate("Total")}</span>{" "}
          <span style={{ fontWeight: "bold", marginLeft: "0.5em" }}>
            {formatHoursMinutes(totalDurationMs)}
          </span>
        </div>
      </div>
      {topDowntimes.map((downtime, i, arr) => {
        const isLast = i === arr.length - 1;
        return (
          <div key={i}>
            <DowntimeBarRow
              {...{
                downtime,
                percentWidth: totalDurationMs
                  ? (downtime.durationMs / totalDurationMs) * 100
                  : 0,
              }}
            />
            {!isLast && <Divider />}
          </div>
        );
      })}
    </TopDowntimesChartStyles>
  );
}
const TopDowntimesChartStyles = styled.div`
  width: 100%;
  &&&& {
    .MuiDivider-root {
      margin: 16px 0;
    }
    .totalDowntime {
      margin-bottom: 32px;
      text-align: left;
      .superscript {
        opacity: 0.8;
      }
      .title {
        font-size: 32px;
      }
    }
  }
`;

function DowntimeBarRow({
  downtime,
  percentWidth,
}: {
  downtime: TopDowntime;
  percentWidth: number;
}) {
  const color = PNL_COLORS[downtime.pnlCategory];
  return (
    <DowntimeBarRowStyles>
      <TooltipNS title={`${percentWidth.toFixed(0)}% of all downtime`}>
        <div
          className="tagBar"
          style={{ width: `${percentWidth}%`, background: color }}
        />
      </TooltipNS>
      <div className="tagBarBottomRow">
        <div className="tagName">{downtime.name}</div>
        <div className="tagDuration">
          {formatHoursMinutes(downtime.durationMs)}
        </div>
      </div>
    </DowntimeBarRowStyles>
  );
}

function formatHoursMinutes(durationMs: number) {
  const hours = Math.floor(durationMs / 1000 / 60 / 60);
  const minutes = Math.floor((durationMs / 1000 / 60) % 60);
  return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(
    2,
    "0"
  )}m`;
}

const DowntimeBarRowStyles = styled.div`
  .tagBarBottomRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  font-size: 24px;
  .tagBar {
    height: 24px;
    border-radius: 2px;
    margin-bottom: 0.5em;
  }
  .tagName {
    text-align: left;
  }
  .tagName,
  .tagDuration {
    font-family: "Open Sans";
  }
  .tagDuration {
    flex-shrink: 0;
    font-weight: bold;
  }
`;
